import React from "react";
import { Box, Button, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Info } from "lucide-react";

interface StatusButtonProps {
  status: string;
  statusColor?: string;
  backgroundColor?: string;
  statusDescription?: string;
}

const StyledStatusButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== "statusColor" && prop !== "backgroundColor",
})<{
  statusColor?: string;
  backgroundColor?: string;
}>(({ statusColor, backgroundColor }) => ({
  fontSize: 12,
  fontWeight: 500,
  textTransform: "capitalize",
  borderRadius: 8,
  backgroundColor: backgroundColor || "transparent",
  border: "none",
  color: statusColor || "#333333",
  padding: "2px 8px",
  display: "flex",
  alignItems: "center",
  textWrap: "nowrap",
  "&:hover": {
    cursor: "default",
    backgroundColor: backgroundColor || "transparent",
    border: "none",
    color: statusColor || "#333333",
  },
}));

const StatusButton: React.FC<StatusButtonProps> = ({
  status,
  statusColor = "#333333",
  backgroundColor = "f0f0f0",
  statusDescription = "",
}) => {
  return (
    <Box className="flex-xy-center">
      <StyledStatusButton
        variant="outlined"
        size="small"
        backgroundColor={backgroundColor}
        statusColor={statusColor}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: statusColor || "#333333",
            mr: 0.75,
          }}
        />
        {status}
        {statusDescription && (
          <Tooltip title={statusDescription} placement="bottom" arrow>
            <Box sx={{ ml: 0.75, display: "flex", alignItems: "center" }}>
              <Info size={14} color={statusColor} />
            </Box>
          </Tooltip>
        )}
      </StyledStatusButton>
    </Box>
  );
};

export default StatusButton;
